import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/CycleCountConfirmationForm';
/*import Table from '../../Tables/DataTable/components/DataTable';*/
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const CycleCountConfirmationForm = ({ t }) => (
  <Container>
    <Row>
     
	 {/* <Col md={3}>
        <a onClick={() => {window.location.href = "/maintenance/cycleCount/assignUser"}} color="primary" class="button_enable " style={{color:'rgb(112, 187, 253)', cursor:'pointer', textDecoration: 'underline',padding:'10px',display:'block'}}>Back to Cycle Count Dashboard</a>
      </Col>*/}
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

    
  </Container>
);

CycleCountConfirmationForm.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(CycleCountConfirmationForm);
